export default {
  enableCustomSignInLinks: true,
  indentProjectJson: true
};
